import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";

import Navbar from "@/components/site/Navbar";
import Hero from "@/components/site/Hero";
import Services from "@/components/site/Services";
import WhyChoose from "@/components/site/WhyChoose";
import Process from "@/components/site/Process";
import Certifications from "@/components/site/Certifications";
import Gallery from "@/components/site/Gallery";
import About from "@/components/site/About";
import ContactForm from "@/components/site/ContactForm";
import Footer from "@/components/site/Footer";
import WhatsAppButton from "@/components/site/WhatsAppButton";

const HomePage = () => {
    useEffect(() => {
        document.title = "Lavlimpar — Limpeza Técnica de Hottes e Sistemas de Extração";
        const observer = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        entry.target.classList.add("in");
                    }
                });
            },
            { threshold: 0.12 }
        );
        document.querySelectorAll(".reveal").forEach((el) => observer.observe(el));
        return () => observer.disconnect();
    }, []);

    return (
        <div data-testid="lavlimpar-home" className="min-h-screen bg-white text-[#0A0A0A] font-body">
            <Navbar />
            <main>
                <Hero />
                <Services />
                <WhyChoose />
                <Process />
                <Certifications />
                <Gallery />
                <About />
                <ContactForm />
            </main>
            <Footer />
            <WhatsAppButton />
        </div>
    );
};

function App() {
    return (
        <div className="App">
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<HomePage />} />
                </Routes>
            </BrowserRouter>
            <Toaster theme="light" position="top-right" richColors closeButton />
        </div>
    );
}

export default App;
